import React, { Component } from 'react'

import style from './style.css'

export class Col extends Component {
    render() {
        let classes = []
        classes.push(style['col'])

        if(this.props.className)
        classes.push(this.props.className)

        if(this.props.size) {
            let sizes = this.props.size.split(' ')
            if(sizes[0]) classes.push(style[`col-${sizes[0]}`])
            if(sizes[1]) classes.push(style[`col-md-${sizes[1]}`])
            if(sizes[2]) classes.push(style[`col-lg-${sizes[2]}`])
        }

        if(this.props.float) {
            let floats = this.props.float.split(' ')
            if(floats[0]) classes.push(style[`col-float-${floats[0]}`])
            if(floats[1]) classes.push(style[`col-md-float-${floats[1]}`])
            if(floats[2]) classes.push(style[`col-lg-float-${floats[2]}`])
        }

        if(this.props.position) {
            let positions = this.props.position.split(' ')
            if(positions[0]) classes.push(style[`col-position-${positions[0]}`])
            if(positions[1]) classes.push(style[`col-md-position-${positions[1]}`])
            if(positions[2]) classes.push(style[`col-lg-position-${positions[2]}`])
        }

        if(this.props.display) {
            let displays = this.props.display.split(' ')
            if(displays[0]) classes.push(style[`col-display-${displays[0]}`])
            if(displays[1]) classes.push(style[`col-md-display-${displays[1]}`])
            if(displays[2]) classes.push(style[`col-lg-display-${displays[2]}`])
        }

        if(this.props.text) {
            let texts = this.props.text.split(' ')
            if(texts[0]) classes.push(style[`col-text-${texts[0]}`])
            if(texts[1]) classes.push(style[`col-md-text-${texts[1]}`])
            if(texts[2]) classes.push(style[`col-lg-text-${texts[2]}`])
        }

        let className = classes.join(' ')

        return (
            <div className={className} style={this.props.style || {}}>
                {this.props.children}
            </div>
        )
    }
}

export class Row extends Component {
    render() {
        let classes = []
        classes.push(style['row'])
        if(this.props.className)
        classes.push(this.props.className)

        let className = classes.join(' ')

        return (
            <div className={className} style={this.props.style || {}}>
                {this.props.children}
            </div>
        )
    }
}

export class Container extends Component {
    render() {
        let classes = []
        classes.push(style['container'])
        if(this.props.className)
        classes.push(this.props.className)

        let className = classes.join(' ')

        return (
            <div className={className} style={this.props.style || {}}>
                {this.props.children}
            </div>
        )
    }
}

export class ContainerFluid extends Component {
    render() {
        let classes = []
        classes.push(style['container-fluid'])
        if(this.props.className)
        classes.push(this.props.className)

        let className = classes.join(' ')

        return (
            <div className={className} style={this.props.style || {}}>
                {this.props.children}
            </div>
        )
    }
}

export class Clearfix extends Component {
    render() {
        let classes = []
        classes.push(style['clearfix'])
        if(this.props.className)
        classes.push(this.props.className)

        let className = classes.join(' ')

        return (
            <div className={className} style={this.props.style || {}}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/atoms-v2/Grid/index.js